export default __webpack_public_path__ + "static/media/megaphone.96973110.svg";